module.exports = __webpack_public_path__ + "img/-s-组1@2x.5db40458.png";